import { quickFacts } from "@/mocks/profile";

export default function QuickFactsSection() {
  return (
    <section id="profile" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl mb-10">
          <p className="font-label text-primary-600 text-xs tracking-[0.25em] mb-3">PROFILE / 档案</p>
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950 mb-4">
            一分钟了解她是谁
          </h2>
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
            下面几条是浏览时最常被问到的信息点。由于部分条目在网络上存在多种说法，这里只做归纳与提示，遇到不一致的地方会如实标注，
            方便你判断哪些是相对稳定的信息，哪些还停留在讨论阶段。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {quickFacts.map((f) => (
            <div
              key={f.label}
              className="bg-background-100 border border-background-200 rounded-lg p-5 md:p-6 hover:border-primary-300 transition-colors"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 text-xl mb-4">
                <i className={f.icon} aria-hidden="true"></i>
              </span>
              <h3 className="font-label text-xs text-foreground-500 tracking-wide mb-1.5">{f.label}</h3>
              <p className="font-heading text-foreground-950 text-lg leading-snug">{f.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}